import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AnalyticsEventRow } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const Row: React.FC<{ label: string; value: number | string }> = ({ label, value }) => (
  <div className="flex justify-between items-center py-1.5 border-b last:border-0 text-sm">
    <span className="text-muted-foreground">{label}</span>
    <span className="font-semibold">{value}</span>
  </div>
);

const FunisCards: React.FC<Props> = ({ events }) => {
  const c = (fn: (e: AnalyticsEventRow) => boolean) => events.filter(fn).length;

  // Funil A — Pagamento direto
  const pagVisits = c((e) => e.event_type === "page_view" && e.path === "/pagamento");
  const pagNubank = c((e) => e.event_type === "direct_payment_nubank_click");
  const pagWhats = c((e) => e.event_type === "direct_payment_whatsapp_click");
  const pagCheckout = c((e) => e.event_type === "checkout_click" && e.metadata?.origin === "pagamento_direto");
  const pagIntent = pagVisits ? Math.round(((pagNubank + pagWhats) / pagVisits) * 100) : 0;

  // Funil B — Planos/Stripe
  const planosVisits = c((e) => e.event_type === "page_view" && e.path === "/planos");
  const planView = c((e) => e.event_type === "plan_view");
  const planosCheckout = c((e) => e.event_type === "checkout_click" && e.metadata?.origin === "planos_stripe");
  const planosIntent = planosVisits ? Math.round((planosCheckout / planosVisits) * 100) : 0;

  // Funil C — WhatsApp geral
  const whatsTotal = c((e) => e.event_type === "whatsapp_click" || e.event_type === "direct_payment_whatsapp_click");
  const whatsFloating = c((e) => e.event_type === "whatsapp_click" && e.metadata?.source === "floating");
  const whatsModal = c((e) => e.event_type === "whatsapp_click" && e.metadata?.source === "modal");
  const whatsBanner = c((e) => e.event_type === "whatsapp_click" && e.metadata?.source === "banner");
  const whatsPag = c((e) => e.event_type === "direct_payment_whatsapp_click");
  const whatsPlanos = c((e) => e.event_type === "whatsapp_click" && e.path === "/planos");

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Funil A — Pagamento direto</CardTitle>
        </CardHeader>
        <CardContent>
          <Row label="Visitas /pagamento" value={pagVisits} />
          <Row label="Cliques Nubank" value={pagNubank} />
          <Row label="Cliques WhatsApp" value={pagWhats} />
          <Row label="checkout_click (origem pag.)" value={pagCheckout} />
          <Row label="Taxa de intenção" value={`${pagIntent}%`} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Funil B — Planos / Stripe</CardTitle>
        </CardHeader>
        <CardContent>
          <Row label="Visitas /planos" value={planosVisits} />
          <Row label="plan_view" value={planView} />
          <Row label="checkout_click (Stripe)" value={planosCheckout} />
          <Row label="Taxa de intenção" value={`${planosIntent}%`} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Funil C — WhatsApp geral</CardTitle>
        </CardHeader>
        <CardContent>
          <Row label="Total WhatsApp" value={whatsTotal} />
          <Row label="Botão flutuante" value={whatsFloating} />
          <Row label="Modal" value={whatsModal} />
          <Row label="Banner" value={whatsBanner} />
          <Row label="Vindo de /pagamento" value={whatsPag} />
          <Row label="Vindo de /planos" value={whatsPlanos} />
        </CardContent>
      </Card>
    </div>
  );
};

export default FunisCards;
